import LiteYTEmbed from 'lite-youtube-embed'; // eslint-disable-line no-unused-vars

// DOM-specific JS should be done here
// see /boilerplate/src/js/browser.js for the import pattern

export const Figure = (el) => {
  /*
  const ui = {
    el,
    body: select('body', document),
  };
  */

  const addEvents = () => {
    // no events
  }

  const init = () => {
    addEvents();
  };

  init();
};

export default Figure;
